<mat-form-field>
    <!-- <mat-label>Choose a date</mat-label> -->
    <input matInput [matDatepicker]="picker" [formControl]="dateCtrl" [min]="minDate">
    <mat-hint>MM/DD/YYYY</mat-hint>
    <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
    <mat-datepicker #picker></mat-datepicker>
</mat-form-field>
@if (dateCtrl.invalid && (dateCtrl.dirty || dateCtrl.touched)) {
  <p class="form-text text-danger">{{'poll_creation.schedule_date_error' | translate}}</p>
}